function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgNumber = function SvgNumber(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 18 18",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M9 0C4 0 0 4 0 9s4 9 9 9 9-4 9-9-4-9-9-9m.3 12H7.8L5.6 7c.1.4.1.8.1 1.2V12h-1V5.8h1.5l2.2 5c0-.2-.1-.6-.1-1s-.1-.8-.1-1.2V5.8h1.1zm4.1-3.7c-.1 0-.3-.1-.4-.1-.3 0-.5.1-.7.3-.1.2-.2.5-.3 1V12h-1.2V7.2h1l.1.9c.1-.3.3-.6.5-.8s.5-.3.7-.3.3 0 .5.1z",
    style: {
      fill: "#374a67"
    }
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgNumber);
export default ForwardRef;